import React from 'react';
import PropTypes from 'prop-types';

const Bluebox = ({ children, aside }) => (
  <div className="bluebox">
    <div className="bluebox__content">{children}</div>
    <div className="bluebox__aside">{aside}</div>
  </div>
);

Bluebox.propTypes = {
  children: PropTypes.array.isRequired,
  aside: PropTypes.object.isRequired,
};

export default Bluebox;
